import React from 'react'

function Impact() {
    const impactData = Array.from({ length: 9 }, (_, i) => ({
        id: i + 1,
        image: '/assets/impact/img1.png',
        text: `300 Trees Planted`,
    }));

    return (
        <>
            <div className='mt-[80px]'>
                <div className='relative'>
                    <img src="/assets/impact/bg2.png" className='w-full' alt="" />
                    <div className='absolute md:bottom-[60px] bottom-[10px] left-[50%] translate-x-[-50%]'>
                        <h2 className="font-[700] font-manrope md:text-[50px] text-[30px] text-[#FFFFFF] tracking-[3px] text-center">Impact</h2>
                        <p className="font-[500] font-manrope text-[16px] text-[#FFFFFF] tracking-[3px] text-center">HOME-Impact</p>
                    </div>
                </div>
            </div>
            <section className="md:pt-[90px] pt-[50px] md:px-[128px] px-[20px] md:pb-[120px] pb-[50px]">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-[30px]">
                    {impactData.map((item) => (
                        <div
                            key={item.id}
                            className="flex flex-col items-center gap-[14px] bg-[#FFFFFF] py-[26px] rounded-[16px] w-full"
                            style={{ boxShadow: "0px 0px 4px 0px #00000014" }}
                        >
                            <img src={item.image} alt="" />
                            <p className="font-[700] font-manrope text-[20px] text-[#333333]">{item.text}</p>
                        </div>
                    ))}
                </div>
            </section>
        </>
    )
}

export default Impact